import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Spinner from '../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { inlineMediaQuery } from '../../App/Util'
import { Notification } from '../Notification/Notification'
import { getNotifications } from '../Notification/store/actions'

import style from './Profile.scss'

export const Profile = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const mediaBreak = inlineMediaQuery('(max-width: 767px)')
  const lastOpened = localStorage.getItem('notifications_last_opened')
  const lastOpenCheck =
    null === lastOpened ? moment().subtract(1, 'year') : moment(lastOpened)

  const notifications = useAppSelector(state => state.notifications.list)

  const isNotificationsLoading = useAppSelector(
    state => state.notifications.loading,
  )

  const user = useAppSelector(state => (state ? state.users.currentUser : null))

  useEffect(() => {
    let timer: any
    if (isOpen) {
      timer = setTimeout(() => {
        localStorage.setItem(
          'notifications_last_opened',
          moment().format('YYYY-MM-DD HH:mm:ss'),
        )
      }, 5000)
    }
    return () => clearTimeout(timer)
  }, [isOpen])

  let avatar = '/img/avatar-female.png'
  if (user) {
    avatar = user.avatar + '&w=64&h=64&fit=crop'
  }

  useEffect(() => {
    if (!isNotificationsLoading && null === notifications) {
      dispatch(getNotifications())
    }
  }, [])

  const openSubMenu = () => setIsOpen(true)
  const closeSubMenu = () => setIsOpen(false)

  const unreadCount = useMemo(
    () =>
      (notifications || []).filter(
        notification =>
          !notification.isRead &&
          moment(notification.createdAt).isAfter(lastOpenCheck),
      ).length,
    [notifications, lastOpenCheck],
  )

  return (
    <>
      <div
        className={'toolbar'}
        style={{
          color: `${mediaBreak ? '#303640' : '#fff'}`,
          height: '48px',
          alignItems: 'center',
          paddingLeft: '10px',
          display: `${!mediaBreak ? 'none' : 'inherit'}`,
        }}>
        {t('Profile')}
      </div>
      <div
        className={style.profile + ' ' + (isOpen ? style.open : '')}
        onMouseEnter={() => openSubMenu()}
        onMouseLeave={() => closeSubMenu()}>
        <img src={avatar} className={style.avatar} alt={t('Profile')} />
        {unreadCount > 0 ? (
          <span className={style.badge}>{unreadCount}</span>
        ) : (
          ''
        )}
        <div className={style.submenu}>
          <div className={style.notifications}>
            {isNotificationsLoading ? (
              <Spinner />
            ) : null === notifications || notifications.length === 0 ? (
              <div className={style.notifications} key={'noProfiles'}>
                <p className={style.noWrap}>
                  <i className={'icon icon-notice'} /> {t('No notifications')}
                </p>
              </div>
            ) : (
              notifications.map(notification => (
                <Notification
                  key={notification.id}
                  notification={notification}
                />
              ))
            )}
          </div>
          <div className={style.actions}>
            <a href={'/profile'}>
              <i className={'icon icon-man'} /> {t('Profile')}
            </a>
            <a href={'/logout'}>
              <i className={'icon icon-logout'} /> {t('Logout')}
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
